import { render, staticRenderFns } from "./cashback-bonus.vue?vue&type=template&id=5246c8b6"
import script from "./cashback-bonus.vue?vue&type=script&lang=js"
export * from "./cashback-bonus.vue?vue&type=script&lang=js"
import style0 from "./cashback-bonus.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/cashback-bonus.vue
// module id = BB1z
// module chunks = 0